// import React, { useEffect, useState } from "react";
// import Header from "../header/header";
// import { getAllTank, updateTankBal } from "../../api/endpoints/saleData"; // Import your API function
// // import "./saleData.css";
// import { useSelector } from "react-redux";
// import { authSelector } from "../../store/selectors/index";
// import { Select, message } from "antd";
// import { format } from "date-fns";
// const { Option } = Select;

// const TankStock = () => {
//   const { user, access_token } = useSelector(authSelector);
//   const [tankData, setTankData] = useState([]);
//   const [state, setState] = useState({
//     tankNumber: [],
//     tankNo: "",
//     openingBal: "",
//   });

//   const onChangeText = (e, object) => {
//     if (object) {
//       const { name, value } = object;
//       setState({
//         ...state,
//         [name]: value,
//       });
//     } else {
//       const { name, value } = e.target;
//       setState({
//         ...state,
//         [name]: value,
//       });
//     }
//   };
//   const clearState = () => {
//     setState({
//       tankNumber: state.tankNumber,
//       tankNo: "",
//       openingBal: ""
//     });
//   };

//   const updateTankBalance = async () => {
//     if (!state.tankNo || !state.openingBal) {
//       return message.error(
//         `Please type ${
//           !(state.tankNo || state.openingBal)
//             ? "Tank Number Required"
//             : !state.openingBal
//             ? "please write stock"
//             : ""
//         }`
//       );
//     } else {
//       const data = {
//         id: state.id,
//         tankNumber: state.tankNo,
//         openingBalence: Number(state.openingBal),
//       };
  
//       console.log(data, "payyyyyyyyy");
//       const response = await updateTankBal(data, access_token);
//       if (response.success) {
//         message.success(response.message);
//         clearState();
//       } else {
//         message.error(response.message);
//       }
//     }
//   };

//   useEffect(() => {
//     const fetchDataFromAPI = async () => {
//       const payload = {
//         siteId: user.siteId,
//       };

//       const results = await getAllTank(access_token);
//       if (results.success) {
//         console.log(results, "payy");
//         setState({
//           ...state,
//           tankNumber: results.data,
//         });
//         setTankData(results.data);
//       } else {
//         message.error(results.message);
//       }
//     };
//     fetchDataFromAPI();
//   }, []);
//   console.log(state, "state");

//   // useEffect(() => {

//   //   const fetchDataFromAPI = async () => {
//   //     const payload = {
//   //       siteId: user.siteId,
//   //     };

//   //     const result = await getNozelSale(payload, access_token);
//   //     if (result.success) {
//   //       setSaleData(result.data);
//   //     } else {
//   //       message.warning(result.message);
//   //     }
//   //   };
//   //   fetchDataFromAPI();

//   // }, [saleData]); // Include user.siteId and access_token in dependency array

//   return (
//     <>
//       <Header />
//       <div className="flex">
//         <>
//           <div className="">
//             <Select
//               showSearch
//               name="tankNumber"
//               className="ant-select ant-select bg-black  text-white ml-3 mt-5 inpTxt  p-1 h-9  w-72"
//               placeholder="Tank Number"
//               optionFilterProp="children"
//               value={state.tankNo || "Tank Number"}
//               onChange={(e) => {
//                 const lCode = state.tankNumber.find((el) => el.id === e);
//                 setState({
//                   ...state,
//                   id: e,
//                   tankNo: lCode.tankNumber,
//                 });
//               }}
//             >
//               {state.tankNumber.length > 0 &&
//                 state.tankNumber.map((el) => (
//                   <Option value={el.id}>{`${el.tankNumber} `}</Option>
//                 ))}
//             </Select>
//           </div>
//           <input
//             type="number"
//             name="openingBal"
//             value={state.openingBal}
//             onChange={onChangeText}
//             placeholder="Opening Balance"
//             className="ant-select bg-black text-white  inpTxt  mt-5 p-1 h-9 ml-3 w-72"
//           />
//           <button
//             onClick={updateTankBalance}
//             className="bg-blue-500 hover:bg-blue-700 text-white flex  ml-3 mt-5 py-1 px-4 rounded"
//           >
//             <span>Add</span>
//           </button>
//         </>
//       </div>
//     </>
//   );
// };

// export default TankStock;
import React, { useEffect, useState } from "react";
import Header from "../header/header";
import { getAllTank, updateTankBal } from "../../api/endpoints/saleData"; // Import your API function
// import "./saleData.css";
import { useSelector } from "react-redux";
import { authSelector } from "../../store/selectors/index";
import { Select, message } from "antd";
import { format } from "date-fns";
import "./tank.css";
const { Option } = Select;

const TankStock = () => {
  const { user, access_token } = useSelector(authSelector);
  const [tankData, setTankData] = useState([]);
  const [state, setState] = useState({
    tankNumber: [],
    tankNo: "",
    openingBal: "",
  });

  useEffect(() => {
    const fetchDataFromAPI = async () => {
      const results = await getAllTank(access_token);
      if (results.success) {
        setState(prevState => ({
          ...prevState,
          tankNumber: results.data,
        }));
        setTankData(results.data);
      } else {
        message.error(results.message);
      }
    };
    fetchDataFromAPI();
  }, []);

  const updateTankBalance = async () => {
    if (!state.tankNo || !state.openingBal) {
      message.error(
        `Please type ${!state.tankNo ? "tank number" : "stock"}`
      );
      return;
    }

    const data = {
      id: state.id,
      tankNumber: state.tankNo,
      openingBalence: Number(state.openingBal),
    };

    const response = await updateTankBal(data, access_token);
    if (response.success) {
      message.success(response.message);
      setState(prevState => ({
        ...prevState,
        tankNo: "",
        openingBal: "",
      }));
    } else {
      message.error(response.message);
    }
  };

  const onChangeText = (e) => {
    const { name, value } = e.target;
    setState(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <>
      <Header />
      <div className="background ">
      <div className="flex flex-col items-center ">
    
           <Select
              showSearch
              name="tankNumber"
              className="ant-select ant-select bg-black  text-white ml-3 mt-5 inpTxt  p-1 h-9  w-72"
              placeholder="Tank Number"
              optionFilterProp="children"
              value={state.tankNo || "Tank Number"}
              onChange={(e) => {
                const lCode = state.tankNumber.find((el) => el.id === e);
                setState({
                  ...state,
                  id: e,
                  tankNo: lCode.tankNumber,
                });
              }}
            >
              {state.tankNumber.length > 0 &&
                state.tankNumber.map((el) => (
                  <Option value={el.id}>{`${el.tankNumber} `}</Option>
                ))}
            </Select>
    
          <input
            type="number"
            name="openingBal"
            value={state.openingBal}
            onChange={onChangeText}
            placeholder="Opening Balance"
            className="ant-select bg-black text-white  inpTxt  mt-5 p-1 h-9 ml-3 w-72"
          />
          <button
            onClick={updateTankBalance}
            className="bg-blue-500 hover:bg-blue-700 text-white flex  ml-3 mt-5 py-1 px-4 rounded"
          >
            <span>Add</span>
          </button>
      </div>
      <div className="tank-details tanksize">
        {tankData.map(tank => (
          <div key={tank.id} className="tank-info">
            <p>{`Tank Number: ${tank.tankNumber}`}</p>
            <p>{`Volume: ${tank.volume} liters`}</p>
            <p>{`Opening Balance: ${tank.openingBalence}`}</p>
          </div>
        ))}
      </div>
      </div>
    </>
  );
};

export default TankStock;
